document.addEventListener("DOMContentLoaded", function () {
  const sidebar = document.getElementById("filtersSidebar");
  const overlay = document.getElementById("filtersOverlay");
  const openBtn = document.getElementById("openFilters");
  const closeBtn = document.getElementById("closeFilters");
  const applyBtn = document.getElementById("applyFiltersBtn");

  const sortSidebar = document.getElementById("sortSidebar");
  const sortOverlay = document.getElementById("sortOverlay");
  const openSortBtn = document.getElementById("openSort");
  const sortChecks = Array.from(document.querySelectorAll(".filter-sort"));

  /* ==========================
     SIDEBAR FILTROS
  ========================== */

  function isFiltersOpen() {
    return sidebar && !sidebar.classList.contains("-p-translate-x-full");
  }

  function isSortOpen() {
    return sortSidebar && !sortSidebar.classList.contains("p-translate-y-full");
  }

  function syncBodyLock() {
    const hasOpenPanel = isFiltersOpen() || isSortOpen();
    document.body.classList.toggle("p-overflow-hidden", hasOpenPanel);
  }

  function openFilters() {
    if (!sidebar || !overlay) return;
    if (typeof window.syncFilterControls === "function") {
      window.syncFilterControls();
    }
    closeSort();
    sidebar.classList.remove("-p-translate-x-full");
    overlay.classList.remove("p-hidden");
    syncBodyLock();
  }

  function closeFilters() {
    if (!sidebar || !overlay) return;
    sidebar.classList.add("-p-translate-x-full");
    overlay.classList.add("p-hidden");
    syncBodyLock();
  }

  if (openBtn) openBtn.addEventListener("click", openFilters);
  if (closeBtn) closeBtn.addEventListener("click", closeFilters);
  if (overlay) overlay.addEventListener("click", closeFilters);
  if (applyBtn) applyBtn.addEventListener("click", closeFilters);

  /* ==========================
     BOTTOM SHEET ORDENAR
  ========================== */

  function openSort() {
    if (!sortSidebar || !sortOverlay) return;
    if (typeof window.syncFilterControls === "function") {
      window.syncFilterControls();
    }
    closeFilters();
    sortSidebar.classList.remove("p-translate-y-full");
    sortOverlay.classList.remove("p-hidden");
    syncBodyLock();
  }

  function closeSort() {
    if (!sortSidebar || !sortOverlay) return;
    sortSidebar.classList.add("p-translate-y-full");
    sortOverlay.classList.add("p-hidden");
    syncBodyLock();
  }

  if (openSortBtn) openSortBtn.addEventListener("click", openSort);
  if (sortOverlay) sortOverlay.addEventListener("click", closeSort);

  sortChecks.forEach((check) => {
    const isInput =
      check.tagName === "INPUT" ||
      check.type === "checkbox" ||
      check.type === "radio";
    const eventName = isInput ? "change" : "click";

    check.addEventListener(eventName, function () {
      closeSort();
      if (typeof window.applyFilters === "function") {
        window.applyFilters();
      }
    });
  });
});
